import React from 'react';
import {
    FlexDiv, TextDefault,
    TextLead,
    TextTiny,
    TextWithTooltipIcon,
} from '@awarego-ui/components';
import { observer } from 'mobx-react';
import Link from '@mui/material/Link';
import CircularProgress from '@mui/material/CircularProgress';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export default observer(
    ({
        name,
        value,
        subtext,
        actionName,
        action,
        actionLoading,
        helpText,
        helpId,
        isLast,
        fullWidth,
        noPb,
        noPt,
        centered,
        isPartnerCompanyDetails,
     }) => {
        return (
            <FlexDiv pt={noPt ? "0" : 20} pb={noPb ? "0" : 20} borderBottom={!isLast} fullWidth={fullWidth}>
                <FlexDiv flexGrow={1} style={ centered ? { alignItems: 'center' } : {}}>
                    {isPartnerCompanyDetails ? (
                        <TextDefault lighter>
                            {helpId ? (
                                <TextWithTooltipIcon
                                    tooltipText={helpText}
                                    textComponent={name}
                                    icon={<HelpOutlineIcon />}
                                />
                            ) : (
                                name
                            )}
                        </TextDefault>
                    ) : (
                    <TextLead bold lighter>
                        {helpId ? (
                            <TextWithTooltipIcon
                                tooltipText={helpText}
                                textComponent={name}
                                icon={<HelpOutlineIcon />}
                            />
                        ) : (
                            name
                        )}
                    </TextLead>
                    )}
                </FlexDiv>
                <FlexDiv column flexGrow={2} ml={32} style={ centered ? { alignItems: 'center' } : {}}>
                    <TextTiny bold>{value}</TextTiny>
                    <TextTiny>{subtext}</TextTiny>
                </FlexDiv>
                {actionName && action && (
                    <FlexDiv justifyEnd flexGrow={1} style={ centered ? { alignItems: 'center' } : {}}>
                        {actionLoading ? (
                            <CircularProgress size={20} />
                        ) : (
                            <Link onClick={action}>
                                <TextLead themed bold link>
                                    {actionName}
                                </TextLead>
                            </Link>
                        )}
                    </FlexDiv>
                )}
            </FlexDiv>
        );
    }
);
